/* ----------------------------------------
    Node Modules
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
    Animations
---------------------------------------- */

const fadeIn = el => {
    anime({
        targets: el,
        opacity: [0, 1],
        easing: 'easeOutQuad',
        duration: 750
    });
};

const fadeOut = el => {
    anime({
        targets: el,
        opacity: [1, 0],
        easing: 'easeOutQuad',
        duration: 500,
        complete: () => {
            if(el) el.remove();
        }
    });
};

/** ----------------------------------------
     Overlay
 ---------------------------------------- */

export class Overlay {

    constructor(layer = 1, parent) {
        this.overlay = null;
        this.parent = document.querySelector(parent) || document.body;
        this.layer = layer;
    }

    /** ----------------------------------------
         Check Active Overlay
     ---------------------------------------- */

    _checkOverlay() {
        let layer = false;
        const overlay = document.querySelector('.overlay');
        const multiple = document.querySelectorAll('.overlay');
        if(overlay) layer = parseInt(overlay.style.zIndex) === this.layer;
        return layer || multiple.length >= 1 && layer;
    }

    /** ----------------------------------------
        Create Overlay
     ---------------------------------------- */

    createOverlay() {
        if(this._checkOverlay()) return;
        const overlay = document.createElement('div');
        overlay.classList.add('overlay');
        overlay.style.zIndex = this.layer;
        this.parent.appendChild(overlay);
        this.overlay = overlay;
        fadeIn(overlay);
        return overlay;
    }

    /** ----------------------------------------
         Remove Overlay
     ---------------------------------------- */

    removeOverlay() {
        fadeOut(this.overlay);
    }

}